import React from 'react'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { UserEditField } from '../../../../../shared/UserEditField'
import {
	ErrorState,
	SettingUserValidators,
	UpdateUserDataField,
	UserFormState,
} from '../../types/settingUserTypes'
import AvatarUploader from '../avatar-uploader/AvatarUploader'

type GeneralInfoBlockProps = {
	userData: UserFormState
	currentUserId?: number
	errorState: ErrorState
	setErrorState: React.Dispatch<React.SetStateAction<ErrorState>>
	validators: SettingUserValidators
	updateUserDataField: UpdateUserDataField
}

const GeneralInfoBlock: React.FC<GeneralInfoBlockProps> = ({
	userData,
	currentUserId,
	errorState,
	setErrorState,
	validators,
	updateUserDataField,
}) => (
	<>
		<AvatarUploader
			initialAvatar={
				typeof userData.avatar === 'string' ? userData.avatar : undefined
			}
			onChange={file => updateUserDataField('avatar', file)}
		/>
		<TypographyPrimary16Bold>Основные данные</TypographyPrimary16Bold>
		<UserEditField
			isErrorFocus={errorState.fullname}
			onBlur={() => validators.fullname()}
			onFocus={() => {
				setErrorState({ ...errorState, fullname: false })
			}}
			maxLength={50}
			isError={errorState.fullname}
			helperText='Укажите Фамилию и Имя'
			value={`${userData.fullname}`}
			width={'100%'}
			id={`userFirstLastName${currentUserId}`}
			label='Фамилия Имя'
			onChange={e => {
				updateUserDataField('fullname', e.target.value)
			}}
		/>
		<UserEditField
			isErrorFocus={errorState.position}
			onBlur={() => validators.position()}
			width={'100%'}
			onFocus={() => {
				setErrorState({ ...errorState, position: false })
			}}
			helperText='Укажите должность'
			key={`userPosition${currentUserId}`}
			value={userData.position}
			id='position'
			label='Должность'
			onChange={e => updateUserDataField('position', e.target.value)}
		/>
	</>
)

export default GeneralInfoBlock
